<div class="container my-4">
<div class="">
    <h5 class="mb-3">Frequently Asked Questions</h5>

    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="pills-SocietiesRegAct2006-tab" data-bs-toggle="pill" data-bs-target="#pills-SocietiesRegAct2006" type="button" role="tab" aria-controls="pills-SocietiesRegAct2006" aria-selected="true">Society Registration under HP Societies Registration Act, 2006</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-SocietiesRegAct1968-tab" data-bs-toggle="pill" data-bs-target="#pills-SocietiesRegAct1968" type="button" role="tab" aria-controls="pills-SocietiesRegAct1968" aria-selected="false">Society Registration under HP Societies Registration Act, 1968</button>
        </li>
      </ul>
      <div class="accordion accordion-flush hod-wise-plan" id="SocietiesFAQ">
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-SocietiesRegAct2006" role="tabpanel" aria-labelledby="pills-SocietiesRegAct2006-tab" tabindex="0">
            
            <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQOne" aria-expanded="false" aria-controls="SocietiesFAQOne">
                    <p class="m-0"> What is a Charitable Society ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQOne" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>A charitable society is a type of non-profit society. It differs from other types of societies in that it centers on philanthropic goals as well as social well-being (e.g. charitable, educational, religious, or other activities serving the public interest or common good).</p>

                    <hr>

                    <p>एक धर्मार्थ सोसाइटी एक प्रकार की गैर लाभकारी सोसाइटी है। यह अन्य प्रकार की  सोइटियों से भिन्न होती है, जिसमें यह परोपकारी लक्ष्यों और सामाजिक कल्याण पर केंद्रित होता है (जैसे धर्मार्थ, शैक्षिक, धार्मिक, या अन्य गतिविधियों जो सार्वजनिक हित या सबकी भलाई के लिए हो।)</p>
            
                  </div>
                </div>
              </div>


              <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQTwo" aria-expanded="false" aria-controls="SocietiesFAQTwo">
                      <p class="m-0">How can I register a new  Charitable Society online ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQTwo" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>To register a new Society you first need to create a user account. After completing the account creation process, you have to log into your account and fill the registration form online and submit it to the corresponding office. While your application is under process, you shall be prompted to submit registration fee. Fee will be verified against the corresponding eChallan number .  After verification of fee, Registration Certificate will be issued to you online.</p>

                    <hr>

                    <p>एक नई संस्था को पंजीकृत करने के लिए आपको पहले एक उपयोगकर्ता खाता बनाना होगा। खाता निर्माण प्रक्रिया को पूरा करने के बाद, आपको अपने खाते में प्रवेश करना होगा और पंजीकरण फ़ॉर्म को ऑनलाइन भरना होगा और उसे संबंधित कार्यालय में जमा करना होगा। जबकि आपके आवेदन की प्रक्रिया चल रही है, आपको पंजीकरण शुल्क जमा करने के लिए कहा जाएगा। आपके द्वारा इ-चालान के माध्यम से जमा किये गए शुल्क का सत्यापन किया जाएगा। शुल्क के सत्यापन के बाद, आपको पंजीकरण प्रमाणपत्र ऑनलाइन जारी किया जाएगा।</p>
            
                  </div>
                </div>
              </div>

              <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQ3" aria-expanded="false" aria-controls="SocietiesFAQ3">
                      <p class="m-0">How can I create an online account for Registration of a Charitable Society ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQ3" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>In the home page, under Society Registration menu, you have to click on 'Apply Online for Society (Charitable/NGO) Registration' menu. On the login page, you have to click on 'Sign Up' button. Here you need to fill all mandatory fields and submit. An Activation Code will be sent to your Registered mobile no and email. Activate your account using the Activation Code. You will be prompted if activation was successful thus creating your account for Registration of Society.</p>

                    <hr>

                    <p>होम पेज में, सोसाइटी पंजीकरण मेनू के तहत आपको 'Apply Online for Society (Charitable/NGO) Registration' मेनू पर क्लिक करना होगा। लॉगइन पेज पर, आपको 'Sign Up' बटन पर क्लिक करना होगा। यहां आपको सभी अनिवार्य क्षेत्रों को भरना और जमा करना होगा। एक सक्रियण कोड आपके पंजीकृत मोबाइल नंबर और ईमेल पर भेजा जाएगा। सक्रियण कोड का उपयोग करके अपने खाते को सक्रिय करें। आपको संकेत दिया जाएगा कि सक्रियण सफल रहा है और इस प्रकार आपके सोसाइटी पंजीकरण  के लिए खाता बन जाएगा।</p>
            
                  </div>
                </div>
              </div>

              <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQ4" aria-expanded="false" aria-controls="SocietiesFAQ4">
                      <p class="m-0">What documents are required for the Registration of Society ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQ4" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>You must have scanned pdf  document of Aadhaar (100KB max)  of all the the members to be registered, Society Byelaws (2MB max) and Proceeding of meeting (100KB max).</p>

                    <hr>

                    <p>आपके पास पंजीकृत होने वाले सभी सदस्यों का आधार (100 KB अधिकतम) , सोसाइटी बीलॉज़ (2 एमबी अधिकतम) और कार्यवाही की बैठक (100 केबी अधिकतम) का स्कैन्ड पीडीएफ दस्तावेज होना चाहिए।</p>
            
                  </div>
                </div>
              </div>

              <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQ5" aria-expanded="false" aria-controls="SocietiesFAQ5">
                      <p class="m-0">How can I know the status of my Application for Registration ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQ5" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>Although, you will be intimated with an Email/ SMS regarding the ongoing approval process of you application at each and every step, you can also check the status yourself by logging into your account. After logging into your account, you will see a dashboard where you can know the status of all your society related applications.</p>

                    <hr>

                    <p>हालांकि, आपको प्रत्येक चरण में आवेदन की चल रही मंजूरी प्रक्रिया के बारे में ईमेल / एसएमएस से सूचित करेंगे, आप अपने खाते में लॉग इन करके खुद स्थिति की जांच कर सकते हैं। अपने खाते में प्रवेश करने के बाद, आप एक डैशबोर्ड देखेंगे जहां आप अपने सभी सोसाइटी संबंधित आवेदनों की स्थिति जान सकते हैं।</p>
            
                  </div>
                </div>
              </div>

              <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQ6" aria-expanded="false" aria-controls="SocietiesFAQ6">
                      <p class="m-0">Do I need to fill all of the Society Registration form at once ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQ6" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>No. For your convenience, we have divided the form into 6 separate forms. You can fill these forms one at a time. Don't forget to click on 'Save as Draft' button before moving to the next form,  otherwise your data will be discarded. Once you click on 'Save as Draft' button, your data will be saved which can be edited later on. You will not be allowed to submit the form until you fill all the 6 forms.</p>

                    <hr>

                    <p>नहीं। आपकी सुविधा के लिए हमने फॉर्म को 6 अलग फॉर्मों में विभाजित किया है। आप एक समय में एक फॉर्म भर सकते हैं। अगले रूप में जाने से पहले 'Save as Draft' बटन पर क्लिक करना न भूलें, अन्यथा आपके डेटा को निरस्त कर दिया जाएगा। एक बार जब आपने 'Save as Draft' बटन पर क्लिक कर दिया तो आपके डाटा को सहेज लिया जाएगा, जो बाद में संपादित किया जा सकता है। जब तक आप सभी 6 फॉर्म न भर लें, आपको फॉर्म जमा करने के लिए अनुमति नहीं दी जाएगी।।</p>
            
                  </div>
                </div>
              </div>

        </div>
        <div class="tab-pane fade" id="pills-SocietiesRegAct1968" role="tabpanel" aria-labelledby="pills-SocietiesRegAct1968-tab" tabindex="0">
            
            <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQ7" aria-expanded="false" aria-controls="SocietiesFAQ7">
                      <p class="m-0">How can a Cooperative Society beregistered ?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQ7" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>Go to Society Registration->Under HP Society Registration Act 1968->Apply Online->Sign Up to Register User in the web portal and then Login with the credentials.</p>
            
                  </div>
                </div>
              </div>

              <div class="accordion-item rounded-3 border-0 shadow mb-2">
                <h2 class="accordion-header">
                  <button class="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#SocietiesFAQ8" aria-expanded="false" aria-controls="SocietiesFAQ8">
                      <p class="m-0">What is the requirements during the online registration of a Cooperative Society?</p>
                  </button>
                </h2>
                <div id="SocietiesFAQ8" class="accordion-collapse collapse" data-bs-parent="#SocietiesFAQ">
                  <div class="accordion-body">
                    
                    <p>You need to have valid an Email-Id, Mobile Number, Scan Copies of Aadhar of each member, Signed Scan Copy of Bye-Laws, Signed Copy of Proceeding of Meeting. </p>

                  </div>
                </div>
              </div>

        </div>
      </div>
    </div>

</div>
</div>